"use strict"

import * as aj from "../aj/index";
import * as actions from "../actions/types";
import _ from "underscore";
import {optional, walk} from "../utils/lang";
import {MENU} from "./types";
import {hasPermission} from "../api/session";
import { isEmpty, isNotEmpty } from "../framework/utils";
import { MENU_ITEM_TYPES } from "../model/menu";
import * as CustomUtils from "../utils/customUtils";

const FORCE_JSON = false;

export function getDefaultState() {
    return {
        menu: [],
        activeItemId: undefined,
    }
}

function isItemValid(item) {
    if (item.type === MENU_ITEM_TYPES.SEPARATOR) {
        return true;
    } else {
        return (item.href !== undefined || isNotEmpty(item.children) || (isNotEmpty(item.onClick) && _.isFunction(item.onClick)))
            && isNotEmpty(item.id);
    }
}

function isItemPermitted(item) {
    return isEmpty(item.permissions) || hasPermission(item.permissions);
}

function sanitizeMenu(menu) {
    const _menu = FORCE_JSON ? JSON.parse(JSON.stringify(menu)) : CustomUtils.deepClone(menu),
        sanitizedMenu = walk(_.filter(_menu, i => isItemValid(i) && isItemPermitted(i)), "children", i => {
            if (isNotEmpty(i.children)) {
                i.children = _.filter(i.children, c => isItemValid(c) && isItemPermitted(c));
            }
        });

    return sanitizedMenu;
}

export const MenuStore = aj.createStore(MENU, (state = getDefaultState(), action) => {
    let menu;

    switch (action.type) {
        case actions.SETUP_MENU:
        case actions.SETUP_CUSTOM_MENU:
            menu = sanitizeMenu(action.menu);
            return _.assign(state, {menu: menu});
        case actions.UPDATE_MENU_ROOT:
            menu = CustomUtils.deepClone(state.menu);
            const id = optional(() => action.root.id),
                rootIndex = _.findIndex(menu, r => r.id === id);
            if (isNotEmpty(rootIndex)) {
                menu[rootIndex] = action.root;
            }
            return _.assign(state, {menu: sanitizeMenu(menu)});
        case actions.SET_ACTIVE_MENU_ITEM:
            return _.assign(state, {activeItemId: action.id});
        case actions.CLEAR_ACTIVE_MENU_ITEM:
            return _.assign(state, {activeItemId: undefined});
    }

})

